// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__TdZQL","summary":"CartItem_summary__1mMtr","price":"CartItem_price__1hb1-","amount":"CartItem_amount__3afFg","actions":"CartItem_actions__37gzo"};